import React from "react";
import { StyledPedagogyTile } from "./_styled";

export default function commentaryProcessor() {
  const processCommentary = (options) => {
    const { children, wrapperNode, processNodes, commentary } = options;
    const { title, info } = commentary;
    const content = processNodes(wrapperNode, children);
    return (
      <StyledPedagogyTile
        barColor="tertiary"
        title={title}
        description={content}
        info={info}
        data-testid="commentary-tile"
      />
    );
  };

  return { processCommentary };
}
